<template>
 <HomePage />
</template>

<script>
import HomePage from "@/components/HomePage.vue"
// import TestVue from "@/components/TestVue.vue";

export default {
  name: 'App',

  components: {
    HomePage,
    // TestVue
  }
 
}
</script>

<style>
@import url("/src/styles/main.css");
</style>

















